import { DepartmentList } from '@/pages/system/department/data'

type Value = string | number
type Values = Value[]

export const getDepartmentOptions = (departmentList: DepartmentList): any[] => {
  return departmentList.map(item => {
    return {
      value: item.department_id,
      label: item.name,
      ...item,
      leaf: !((item.subs?.length as number) > 0),
      [item.subs && item.subs.length ? 'children' : '']:
        item.subs && item.subs.length ? getDepartmentOptions(item.subs) : [],
    }
  })
}

export const getSubDepartmentIds = (
  departmentList: DepartmentList,
  departmentId: Value,
  parentIds: Values = []
): Values => {
  if (!departmentId || !departmentList) {
    return []
  }
  let departmentIds: Values = []
  departmentList.forEach(item => {
    if (item.department_id === departmentId) {
      departmentIds = [...parentIds, item.department_id]
    } else if (item.subs && item.subs.length) {
      const subDepartmentId = getSubDepartmentIds(item.subs, departmentId, [
        ...parentIds,
        item.department_id,
      ])

      if (subDepartmentId && subDepartmentId.length) {
        departmentIds = subDepartmentId
      }
    }
  })

  return departmentIds
}

export const getDepartmentIds = (
  departmentList: DepartmentList,
  departmentId: Value,
  parentIds: Values = []
): Values => {
  const departmentIds = getSubDepartmentIds(departmentList, departmentId, parentIds)

  if (departmentIds && departmentIds.length) {
    return departmentIds
  }

  if (departmentId) {
    return [departmentId]
  }
  return []
}
